skrilla.controller('tournamentDetailsCtrl', function ($scope, searchService, $stateParams, modalService, cacheService, dataService, srefService, paginationService) {
    $scope.sport = $stateParams.sport;
    cacheService.registerObject("contestSport", $scope.sport);
    $scope.validate = {}
    $scope.matchesKey = "tournamentMatches";

    searchService.get("tournaments/" + $stateParams.id).then(function(response){
        $scope.tournament = response.data;
    })

    $scope.mergeTournament = function(){
        cacheService.registerObject("tournament", $scope.tournament);
        modalService.openModal("views/mergeTournamentModal/mergeTournamentModal.html", true, 'lg', true, true);
    }

    $scope.save = function(){
        if(dataService.validateTournament($scope.tournament, $scope.validate)) {
            modalService.confirm("Are you sure you'd like to update this tournament?", function () {
                searchService.put("tournaments/" + $scope.tournament.id, $scope.tournament, "Successfully updated").then(function (response) {

                });
            });
        }
    }

    $scope.getMatches = function(){
        searchService.get("matches/?tournament=" + $stateParams.id ).then(function(response1){
            if (response1.data.length > 0) {
                $scope.matches = response1.data.flatMap(function(season){
                    return season.matches;
                });
            }
        });
    }

    $scope.createMatch = function(){
        srefService.go("createMatch", {sport: $scope.tournament.sport, tournamentId: $stateParams.id})
    }

    $scope.createSeason = function(){
        cacheService.registerObject("tournamentId", $scope.tournament.id);
        cacheService.registerObject("sport", $scope.tournament.sport);
        modalService.openModal("views/createSeason/createSeason.html", true, 'lg', true, true)
    }

});
